import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FaSquareXTwitter, FaWhatsapp } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io5";

const Footer = () => {
  return (
    <div>
      <footer id="footer" className="footer light-background">
        <div className="container footer-top">
          <div className="row gy-4 leftspace">
            {/* Footer About */}
            <div className="col-lg-5 col-md-6 footer-about">
              <h4> SEXOLOGY SPECIALITY CLINIC</h4>
              <div className="footer-contact">
                <strong>Address:</strong>{" "}
                <Link to='https://maps.app.goo.gl/5P19RsUVGskXwXQG6' target='_blank' className='text-decoration-none'>
                  <p>ISBT Road, Shanti Nagar, Jabalpur, GCF Jabalpur, Madhya Pradesh 482002</p>
                </Link>

                <p className="mt-3">
                  <strong>Phone:</strong>
                  <Link to="tel:+918989447040" className='text-dark fs-6 text-decoration-none'>
                    <span className='text-dark fs-6 pl-2'>8989447040</span>
                  </Link>
                  <Link to="tel:+919039303090" className='text-dark fs-6 text-decoration-none'>
                    <span className='text-dark fs-6 pl-2'>9039303090</span>
                  </Link>
                </p>

                <p>
                  <strong>Email: </strong>
                  <Link to="mailto:homesexologyclinic@gmail.com" className='text-dark fs-6 pl-2 text-decoration-none'>
                    homesexologyclinic@gmail.com
                  </Link>
                </p>
              </div>

              <div className="social-links d-flex mt-4">
                <Link to="https://x.com" target="_blank" className="twitter footericons text-decoration-none">
                  <FaSquareXTwitter />
                </Link>
                <Link to="https://www.facebook.com" target="_blank" className="facebook footericons">
                  <FaFacebook />
                </Link>
                <Link to="https://www.instagram.com" target="_blank" className="instagram footericons">
                  <FaInstagram />
                </Link>
                <Link to="https://youtube.com" target="_blank" className="youtube footericons">
                  <IoLogoYoutube />
                </Link>
                <Link to="https://wa.me/919039303090" target="_blank" className="whatsapp footericons">
                  <FaWhatsapp />
                </Link>
              </div>
            </div>

            {/* Spacer Column */}
            <div className='col-lg-1'></div>

            {/* Quick Links and Our Services in one row even on mobile */}
            <div className="col-lg-6 col-md-6">
              <div className="row">
                {/* Quick Links */}
                <div className="col-6 footer-links">
                  <h4>Quick Links</h4>
                  <ul>
                    <li><Link to="/" className='text-decoration-none text-dark fs-6'>Home</Link></li>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>Services</Link></li>
                    <li><Link to="/medicines" className='text-decoration-none text-dark fs-6'>Medicine Plan</Link></li>
                    <li><Link to="/aboutus" className='text-decoration-none text-dark fs-6'>About Us</Link></li>
                    <li><Link to="/contact" className='text-decoration-none text-dark fs-6'>Contact Us</Link></li>
                  </ul>
                </div>

                {/* Current Services */}
                <div className="col-6 footer-links">
                  <h4>Current Services</h4>
                  <ul>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>Strength & Stamina</Link></li>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>Timing Concern (PE)</Link></li>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>Less Desire</Link></li>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>Male Problem</Link></li>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>Performance Anxiety</Link></li>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>Male Fertility Support</Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className='copyright'>
          <div className="container copyright text-center">
            <p>© <span>Copyright 2024</span> <strong className="px-1 sitename">Sexologist Clinic</strong> <span>All Rights Reserved</span></p>
            <div className="credits">
              Designed & Developed by <Link to="https://yashsoftsolution.com/" target="_blank" className='text-decoration-none text-light fs-6'>Yashsoft Solution</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
